module.exports = __webpack_public_path__ + "img/CV-HIRE.e3a000b1.svg";